import React, { useEffect, useState } from "react";

export default function Career() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        top: windowWidth > 768 ? "125px" : "0px",
        marginBottom: "10vh",
        marginTop: "10vh",
        padding: windowWidth > 768 ? "80px" : "20px",
        height: "fit-content",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "40px" }}>
        Careers at JSS University, Noida
      </h1>
      <h3
        style={{
          textAlign: "center",
          marginBottom: "40px",
          fontStyle: "italic",
        }}
      >
        Educate. Empower. Excel.
      </h3>

      {/* Introduction Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <p>
          At JSS University, Noida, we are building a transformative academic
          ecosystem that inspires knowledge creation, fosters innovation, and
          nurtures future-ready leaders. Backed by the legacy of JSS
          Mahavidyapeetha, we are committed to excellence in education,
          research, and societal impact.
        </p>
        <p>
          We invite dynamic educators and scholars to join us in our journey of
          nation-building through holistic and inclusive higher education.
        </p>
      </section>

      {/* Career Opportunities Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>
          Career Opportunities Across Departments (Teaching & Non-Teaching)
        </h2>
        <p>
          We welcome academic professionals across disciplines to express
          interest in future opportunities in the following areas:
        </p>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            Engineering (UG, PG, Ph.D) – CSE, IT, CSE-AIML, CSE-DS, ECE, RAI,
            EE, EEE, CE, ME
          </li>
          <li style={{ marginBottom: "10px" }}>
            Computer Applications – (MCA/Ph.D)
          </li>
          <li style={{ marginBottom: "10px" }}>
            Management Studies – (MBA/Ph.D) General, Digital Marketing, Finance
          </li>
          <li style={{ marginBottom: "10px" }}>
            Applied Sciences – (M.Sc./Ph.D) Physics, Chemistry, and Mathematics
          </li>
          <li style={{ marginBottom: "10px" }}>
            Humanities – (M.A/Ph.D) - English & Economics
          </li>
          <li style={{ marginBottom: "10px" }}>
            Pharmacy (D.Pharm, B.Pharm, M.Pharm, Ph.D) - Pharmacology,
            Pharmaceutics, Regulatory Affairs, Pharmaceutical Analysis
          </li>
          <li style={{ marginBottom: "10px" }}>Administration</li>
          <li style={{ marginBottom: "10px" }}>Stores and Purchase</li>
          <li style={{ marginBottom: "10px" }}>Examination Section</li>
          <li style={{ marginBottom: "10px" }}>Registrar Section</li>
        </ul>
      </section>

      {/* Current Openings Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>🔔 Current Openings (Faculty Positions)</h2>
        <p>We are currently inviting applications for:</p>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>Assistant Professor</li>
          <li style={{ marginBottom: "10px" }}>Associate Professor</li>
          <li style={{ marginBottom: "10px" }}>Professor</li>
        </ul>
        <p>
          in CSE, CSE-AIML, CSE-DS, IT, ECE, MCA; MBA-Finance, Digital
          Marketing, General, HR, Strategy; PHARMACY - Pharmacology,
          Pharmaceutics, Regulatory Affairs, Pharmaceutical Analysis; M.Sc –
          Physics, Chemistry, Maths; M.A – English, Economics Departments.
        </p>
        <p>
          Applicants should demonstrate strong teaching capabilities, research
          potential, and a commitment to academic excellence.
        </p>
      </section>

      {/* Eligibility Criteria Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Eligibility Criteria</h2>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>As per UGC/AICTE/PCI norms</li>
          <li style={{ marginBottom: "10px" }}>
            Ph.D. is mandatory for Associate Professor and Professor roles
          </li>
          <li style={{ marginBottom: "10px" }}>
            Prior teaching and research experience preferred
          </li>
        </ul>
      </section>

      {/* How to Apply Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>How to Apply</h2>
        <p>
          Interested candidates are requested to apply through the Google Form
          by submitting their detailed resume, cover letter, and relevant
          documents.
        </p>
        <p>
          📄{" "}
          <a
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfOYmrPE7yxbd_Z1ryfIFXc0mh_ZUoEBI0jxoFbvBvLE0SYdQ/viewform"
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            Click here to apply
          </a>
        </p>
        <p>
          📌 <strong>Note:</strong> Please ensure that you select the correct
          Position and Department in the form.
        </p>
      </section>

      {/* Why JSS University Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Why JSS University, Noida?</h2>
        <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
          <li style={{ marginBottom: "10px" }}>
            🌱 <strong>Educate:</strong> Engage in NEP 2020-driven,
            student-centric teaching
          </li>
          <li style={{ marginBottom: "10px" }}>
            🚀 <strong>Empower:</strong> Grow professionally with research,
            funding, and collaboration opportunities
          </li>
          <li style={{ marginBottom: "10px" }}>
            🏆 <strong>Excel:</strong> Thrive in a supportive,
            interdisciplinary, and globally connected environment
          </li>
        </ul>
      </section>

      {/* Contact Information Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Contact Us</h2>
        <p>
          Join us in shaping the next generation of leaders, innovators, and
          professionals.
        </p>
        <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
          <li style={{ marginBottom: "10px" }}>
            🌐 <strong>Website:</strong>{" "}
            <a
              href="http://www.jssuninoida.edu.in"
              style={{ color: "#007bff", textDecoration: "none" }}
            >
              www.jssuninoida.edu.in
            </a>
          </li>
          <li style={{ marginBottom: "10px" }}>
            📍 <strong>Campus:</strong> C-20/1 Sector 62, Noida
          </li>
          <li style={{ marginBottom: "10px" }}>
            📞 <strong>Phone:</strong> +91-7599201722
          </li>
          <li style={{ marginBottom: "10px" }}>
            ✉️ <strong>Email:</strong>{" "}
            <a
              href="mailto:career@jssuninoida.edu.in"
              style={{ color: "#007bff", textDecoration: "none" }}
            >
              career@jssuninoida.edu.in
            </a>
          </li>
        </ul>
      </section>
    </div>
  );
}
